import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { FaDollarSign } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';

import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

export const Close: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
Close.Icon = styled(IoMdClose)`
  font-size: 24px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Header: any = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
`;
Header.Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  line-height: normal;
`;
Header.Sub = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
  margin: 0;
`;

export const Content: any = styled.div`
  overflow: hidden;
  margin-left: -16px;
  margin-right: -16px;
`;

Content.Slide = styled.div`
  position: relative;
  overflow-x: scroll;
  overflow-y: scroll;
  white-space: nowrap;
  padding-bottom: 60px;
  padding-right: 16px;
  scroll-snap-type: x mandatory;
`;

export const Box: any = styled.div`
  margin-top: 19px;
  border-radius: 8px;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 10%);
  width: 319px;
  margin-left: 16px;
  display: inline-block;
`;

Box.Header = styled.div`
  position: relative;
  height: 56px;
  padding: 0 16px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray5};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Title = styled.span`
  ${_ellipsis()};
  max-width: 190px;
  font-size: 18px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Price = styled.span`
  padding-top: 2px;
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
`;

Box.Content = styled.div`
  height: calc(100vh - 305px);
  overflow: auto;
`;

Box.Button = styled.div`
  padding: 16px;
`;

Box.Category = styled.div`
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray5};
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

Box.Icon = styled.span`
  font-size: 14px;
  margin-right: 11px;
  margin-top: 2px;
  width: 20px;
  text-align: center;
`;

Content.Category = styled.div`
  max-width: calc(100% - 30px);
  margin-left: 5px;
`;

Content.Title = styled.span`
  white-space: normal;
  font-size: 14px;
  font-family: normal;
  color: ${ColorPalette.HEX.PineTree};
`;

Content.Subtitle = styled.span`
  ${_ellipsis()};
  font-size: 12px;
  font-family: normal;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const ChargeIcon = styled(FaDollarSign)`
  width: 14px;
  height: 14px;
  color: ${ColorPalette.HEX.VividGamboge} !important;
  vertical-align: bottom;
`;

export const Icon = styled.span`
  width: 16px;
  height: 16px;
  line-height: 1em;
`;

export const LoaderContainer = styled.div`
  min-height: 500px;
  display: flex;
`;

export const ArrowButton = styled.div`
  position: absolute;
  cursor: pointer;
  top: 50%;
  font-size: 20px;
  padding: 6px;
  border-radius: 50%;
  background-image: ${({ theme }) => theme.button.background};
  color: ${ColorPalette.HEX.White};
  height: 40px;
  width: 40px;
  line-height: 1;
  box-shadow: rgba(${ColorPalette.RGB.DeepTaupe2}, 0.2) 0px 6px 10px 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  & .icons {
    color: ${ColorPalette.HEX.White};
  }
`;

export const PrevButton: any = styled(ArrowButton)`
  left: 28px;
  transform: translateY(-50%) translateX(-50%);
  visibility: visible;
  i {
    display: inline-block;
    transform: rotate(180deg);
  }

  @media only screen and (max-width: 600px) {
    visibility: hidden;
  }
`;

PrevButton.Icon = styled(BsArrowLeft)``;

export const NextButton: any = styled(ArrowButton)`
  right: 28px;
  transform: translateY(-50%) translateX(50%);
  visibility: visible;

  @media only screen and (max-width: 600px) {
    visibility: hidden;
  }
`;

NextButton.Icon = styled(BsArrowRight)``;
